(() => {
  function init() {
    document.querySelectorAll('[data-k4y-wizard]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const unit = root.dataset.k4yWizard === 'unit';
      const last = unit ? 5 : 4;
      const panels = [...root.querySelectorAll('.psh-step-panel')];
      let step = 1;
      let history = [];
      const answers = { temperature: panels[0].querySelector('[data-value].is-active')?.dataset.value || '', known: false, refrigerants: [] };
      const power = root.querySelector('[data-field="power"]');
      const dimensions = ['length', 'width', 'height'].map(key => root.querySelector(`[data-field="${key}"]`)).filter(Boolean);
      const buttons = [...root.querySelectorAll('[data-multi-value]')];
      const values = new Set();
      buttons.forEach(button => {
        const value = button.dataset.multiValue.trim();
        if (values.has(value)) button.remove();
        values.add(value);
        button.setAttribute('aria-pressed', 'false');
      });
      root.querySelectorAll('[data-value]').forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('is-active'))));
      function valid(panel) {
        const input = panel.querySelector('[data-field="power"]');
        if (input) return input.checkValidity() && Number(input.value) > 0;
        if (unit && Number(panel.dataset.step) === 4) return dimensions.every(input => Number(input.value) > 0 && input.checkValidity());
        if (Number(panel.dataset.step) === last) return answers.refrigerants.length > 0;
        return true;
      }
      function validate() {
        panels.forEach(panel => panel.querySelectorAll('[data-next],[data-result]').forEach(button => {
          button.disabled = !valid(panel);
          button.classList.toggle('is-disabled', button.disabled);
        }));
      }
      function destination(consult) {
        const url = new URL(root.dataset.resultUrl, location.origin);
        const source = new URL(location.href);
        if (source.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', source.searchParams.get('preview_theme_id'));
        if (answers.temperature) url.searchParams.set('k4y_temperature', answers.temperature);
        url.searchParams.set('k4y_wizard', '1');
        if (answers.known && Number(power.value) > 0) url.searchParams.set('k4y_power', power.value);
        if (unit && !answers.known) dimensions.forEach(input => { if (Number(input.value) > 0) url.searchParams.set(`k4y_${input.dataset.field}`, input.value); });
        if (unit && !answers.known) {
          for (const key of ['insulation', 'goods', 'loading', 'opening', 'ambient']) {
            const value = root.querySelector(`[data-field="${key}"]`)?.value.trim();
            if (value) url.searchParams.set(`k4y_${key}`, value.slice(0, 150));
          }
        }
        const refrigerants = answers.refrigerants.filter(value => /^R\d+[A-Za-z]?$/u.test(value));
        if (refrigerants.length) url.searchParams.set('f.kaeltemittel', refrigerants.join('|'));
        url.hash = consult || !answers.known ? 'K4YAdviceForm' : 'k4y-katalog';
        return url;
      }
      function show(next, focus = true) {
        step = next;
        panels.forEach(panel => {
          const active = Number(panel.dataset.step) === step;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (active && focus) { const heading = panel.querySelector('h2'); heading.tabIndex = -1; heading.focus(); }
        });
        const progress = root.querySelector('[data-psh-progress]');
        if (progress) progress.style.width = `${step / last * 100}%`;
        root.querySelectorAll('[data-k4y-consult]').forEach(a => { a.href = destination(true).href; });
        const note = root.querySelector('[data-k4y-rating-note]');
        if (note) note.textContent = answers.temperature === 'TK' ? root.dataset.labelRatingTk : root.dataset.labelRatingNk;
        const result = root.querySelector('[data-result]');
        if (result) result.textContent = answers.known ? root.dataset.labelResult : root.dataset.labelConsult;
        validate();
      }
      root.addEventListener('input', validate);
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (event.target.closest('[data-k4y-consult]')) {
          const link = event.target.closest('[data-k4y-consult]');
          const url = destination(true);
          if (link.hasAttribute('data-k4y-unknown-temperature')) url.searchParams.delete('k4y_temperature');
          link.href = url.href;
          return;
        }
        if (!button) return;
        const panel = button.closest('[data-step]');
        if (!panel) return;
        if (button.hasAttribute('data-value')) {
          panel.querySelectorAll('[data-value]').forEach(b => { b.classList.toggle('is-active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
          if (step === 1) answers.temperature = button.dataset.value;
          if (step === 2) answers.known = button.dataset.value === root.dataset.powerYes;
        }
        if (button.hasAttribute('data-multi-value')) {
          const value = button.dataset.multiValue;
          const index = answers.refrigerants.indexOf(value);
          if (index >= 0) answers.refrigerants.splice(index, 1);
          else if (!/^R\d+[A-Za-z]?$/u.test(value)) answers.refrigerants = [value];
          else { answers.refrigerants = answers.refrigerants.filter(v => /^R\d+[A-Za-z]?$/u.test(v)); answers.refrigerants.push(value); }
          root.querySelectorAll('[data-multi-value]').forEach(b => { const active = answers.refrigerants.includes(b.dataset.multiValue); b.classList.toggle('is-active', active); b.setAttribute('aria-pressed', String(active)); });
        }
        if (button.hasAttribute('data-next') && valid(panel)) {
          const next = step === 1 ? 2 : step === 2 ? answers.known ? 3 : unit ? 4 : last : last;
          history.push(step);
          show(next);
        } else if (button.hasAttribute('data-back')) show(history.pop() || 1);
        else if (button.hasAttribute('data-result') && valid(panel)) location.assign(destination(!answers.known).href);
        validate();
      });
      show(1, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
